import { createFileRoute } from '@tanstack/react-router';
import { AdminStaffPage } from '../../features/identity';

export const Route = createFileRoute('/admin/staff')({ component: AdminStaffPage });
